import JobPage from "@/Job/JobPage.vue";
import JobsIndex from "@/Job/JobsIndex.vue";

export default [
  {
    path: "/jobs",
    name: "JobsIndex",
    component: JobsIndex,
    meta: {
      permissionRoles: ["jobs"]
    }
  },
  {
    path: "/jobs/:id",
    name: "JobPage",
    component: JobPage,
    meta: {
      permissionRoles: ["jobs"]
    }
  }
];
